module.exports = __webpack_public_path__ + "img/undraw_Social_expert_re_elbp.09a12b76.svg";